import { render, staticRenderFns } from "./WillLocation.vue?vue&type=template&id=59c00e62&scoped=true"
import script from "./WillLocation.vue?vue&type=script&lang=js"
export * from "./WillLocation.vue?vue&type=script&lang=js"
import style0 from "./WillLocation.vue?vue&type=style&index=0&id=59c00e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c00e62",
  null
  
)

export default component.exports